import { render } from "./ControlloFattureAcquisto.vue?vue&type=template&id=ec0c1838&scoped=true"
import script from "./ControlloFattureAcquisto.vue?vue&type=script&lang=js"
export * from "./ControlloFattureAcquisto.vue?vue&type=script&lang=js"

import "./ControlloFattureAcquisto.vue?vue&type=style&index=0&id=ec0c1838&scoped=true&lang=css"

import exportComponent from "/Users/andreacotugno/Documents/AGF-Workspace/ask_admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ec0c1838"]])

export default __exports__